import React from 'react';

const Cart = (props) => {
    const cart = props.cart;
    // const total = cart.reduce((total, item) => total + item.price, 0);
    let productPrice = 0;
    for(let i=0; i<cart.length; i++) {
        productPrice += cart[i].price;
    }
    let shipping = 12.99;
    if(productPrice >= 100) shipping = 0;
    else if(productPrice >=50) shipping = 6.99;
    else if(productPrice===0) shipping=0;

    const vat = (productPrice/10);
    const total = (productPrice+shipping+vat);

    const FormatNum = num => {
        const precision = num.toFixed(2);
        return Number(precision);
    }
    return (
        <div>
            <h3>Order Summary</h3>
            <p>Items Ordered : {cart.length}</p>
            <p>Product Price : {FormatNum(productPrice)}</p>
            <p>Shipping Cost : {FormatNum(shipping)}</p>
            <p>Vat + tax     : {FormatNum(vat)}</p>
            <p>Total Price   : {FormatNum(total)}</p>
        </div>
    );
};

export default Cart;